import Button from '@/components/base/Button';

export default function CTASection() {
  return (
    <section className="py-20 md:py-28 bg-background-50 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-6 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4">
            Pronto para encontrar seus produtos?
          </h2>
          <p className="text-foreground-500 text-base md:text-lg mb-8">
            Mais de 3000 itens atualizados diariamente no melhor cssbuy spreadsheet do Brasil.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Button
              href="https://kaspreadsheet.com"
              variant="primary"
              size="lg"
              className="gap-2"
            >
              Acessar CSSBuy Spreadsheet
              <i className="ri-arrow-right-line text-lg"></i>
            </Button>
            <Button
              href="/guia-de-compras"
              variant="outline"
              size="lg"
            >
              Ver Guia Completo
            </Button>
          </div>
        </div>

        {/* Product image strip */}
        <div className="flex gap-3 md:gap-4 justify-center flex-wrap">
          <div className="w-36 h-44 md:w-44 md:h-52 rounded-2xl overflow-hidden bg-background-100">
            <img
              src="https://readdy.ai/api/search-image?query=Colorful%20sneakers%20displayed%20on%20rotating%20pedestal%20in%20sneaker%20store%2C%20dynamic%20retail%20display%2C%20vibrant%20neon%20accent%20lighting%2C%20streetwear%20boutique%20atmosphere%2C%20limited%20edition%20footwear%20showcase%2C%20urban%20retail%20photography%2C%20electric%20energy%2C%20creative%20product%20presentation%2C%20bold%20colors%20against%20dark%20background&width=400&height=500&seq=cta-v2-01&orientation=portrait"
              alt="Produto CSSBuy"
              className="w-full h-full object-cover object-top"
              loading="lazy"
            />
          </div>
          <div className="w-36 h-44 md:w-44 md:h-52 rounded-2xl overflow-hidden bg-background-100">
            <img
              src="https://readdy.ai/api/search-image?query=Oversized%20graphic%20hoodie%20worn%20by%20model%20in%20urban%20rooftop%20setting%2C%20golden%20hour%20sunset%20backlight%2C%20city%20skyline%20silhouette%20background%2C%20streetwear%20fashion%20editorial%2C%20wind%20blowing%20fabric%2C%20dramatic%20warm%20orange%20and%20pink%20sky%2C%20lifestyle%20fashion%20photography%2C%20aspirational%20urban%20aesthetic%2C%20freedom%20and%20style%20mood&width=400&height=500&seq=cta-v2-02&orientation=portrait"
              alt="Produto CSSBuy"
              className="w-full h-full object-cover object-top"
              loading="lazy"
            />
          </div>
          <div className="w-36 h-44 md:w-44 md:h-52 rounded-2xl overflow-hidden bg-background-100">
            <img
              src="https://readdy.ai/api/search-image?query=Vintage%20wash%20t-shirt%20hanging%20on%20clothesline%20in%20sunny%20Mediterranean%20courtyard%2C%20whitewashed%20walls%20and%20bougainvillea%20flowers%2C%20summer%20vacation%20aesthetic%2C%20soft%20breeze%20moving%20fabric%2C%20warm%20terracotta%20and%20cream%20tones%2C%20relaxed%20European%20lifestyle%20photography%2C%20dreamy%20afternoon%20light%2C%20peaceful%20laundry%20day%20scene&width=400&height=500&seq=cta-v2-03&orientation=portrait"
              alt="Produto CSSBuy"
              className="w-full h-full object-cover object-top"
              loading="lazy"
            />
          </div>
          <div className="w-36 h-44 md:w-44 md:h-52 rounded-2xl overflow-hidden bg-background-100">
            <img
              src="https://readdy.ai/api/search-image?query=Designer%20baseball%20cap%20placed%20on%20stack%20of%20vintage%20fashion%20magazines%2C%20creative%20studio%20flat%20lay%2C%20warm%20afternoon%20sunlight%20casting%20geometric%20shadows%2C%20artistic%20styling%20with%20dried%20flowers%2C%20retro%20modern%20aesthetic%2C%20fashion%20editor%20desk%2C%20curated%20creative%20workspace%2C%20soft%20muted%20color%20palette%2C%20thoughtful%20composition&width=400&height=500&seq=cta-v2-04&orientation=portrait"
              alt="Produto CSSBuy"
              className="w-full h-full object-cover object-top"
              loading="lazy"
            />
          </div>
          <div className="hidden md:block w-36 h-44 md:w-44 md:h-52 rounded-2xl overflow-hidden bg-background-100">
            <img
              src="https://readdy.ai/api/search-image?query=Premium%20leather%20crossbody%20bag%20resting%20on%20velvet%20armchair%20in%20boutique%20hotel%20lobby%2C%20luxury%20travel%20aesthetic%2C%20warm%20ambient%20chandelier%20lighting%2C%20sophisticated%20interior%20design%2C%20marble%20floors%20and%20brass%20accents%2C%20high%20end%20fashion%20accessory%20photography%2C%20refined%20elegant%20atmosphere%2C%20cream%20and%20gold%20tones&width=400&height=500&seq=cta-v2-05&orientation=portrait"
              alt="Produto CSSBuy"
              className="w-full h-full object-cover object-top"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}